(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aka-ny-product-section"] && !Shopify.designMode) return;
  try {
    
  

  var productCards = document.querySelectorAll('.csm-products-grid .productgrid--item');

  for (var i = 0; i < productCards.length; i++) {
    var card = productCards[i];
  
    // Set card to relative so overlay can be positioned absolutely inside
    card.style.position = 'relative';
    card.style.overflow = 'hidden'; // Optional, keeps overlay within card
  
    var productItemAction = card.querySelector('.productitem--actions'); 
  
    // Set styles for overlay
    productItemAction.style.position = 'absolute';
    productItemAction.style.background = '#ffffff';
    productItemAction.style.bottom = '5px';
    productItemAction.style.left = '0';
    productItemAction.style.minHeight = '50px'; 
    productItemAction.style.visibility = 'hidden';
    productItemAction.style.opacity = '0';
    productItemAction.style.transition = 'opacity 0.3s ease, visibility 0.3s ease';
    productItemAction.style.zIndex = '999';
    productItemAction.style.display = 'flex';
  
    // Add hover listeners
    card.addEventListener('mouseenter', function () {
      var productItemAction = this.querySelector('.productitem--actions');
      productItemAction.style.visibility = 'visible';
      productItemAction.style.opacity = '1';
    });
  
    card.addEventListener('mouseleave', function () {
      var productItemAction = this.querySelector('.productitem--actions');
      productItemAction.style.opacity = '0';
  
      setTimeout(function () {
        if (productItemAction.style.opacity === '0') {
          productItemAction.style.visibility = 'hidden';
        }
      }, 300);
    });
  }
 

  } catch(e) { console.error(e); }
})();
})();
